import styles from './AdvantagesSection.module.scss'
import SectionTitle from '../SectionTitle/SectionTitle'

const advantages = [
	{
		id: 1,
		title: 'Участие в олимпиадах',
		description:
			'Ребёнок сможет применять полученные знания на практике, участвовать в соревнованиях и развивать конкурентные навыки, что повысит его уверенность в себе.',
		image: '/img/advantages/olympiads.svg',
	},
	{
		id: 2,
		title: 'Отсутствие зубрежки',
		description:
			'Обучение строится на практических заданиях и проектах, что позволяет ребёнку осваивать материал естественно и без скучного заучивания.',
		image: '/img/advantages/no-memorization.svg',
	},
	{
		id: 3,
		title: 'Востребованная профессия',
		description:
			'Освоение программирования и разработки открывает двери к перспективным профессиям, которые высоко ценятся на современном рынке труда.',
		image: '/img/advantages/demanded-profession.svg',
	},
	{
		id: 4,
		title: 'Командная работа',
		description:
			'Ребёнок научится работать в команде, распределять задачи и эффективно взаимодействовать с другими участниками, что важно для будущей профессии.',
		image: '/img/advantages/teamwork.svg',
	},
	{
		id: 5,
		title: 'Сильные преподаватели',
		description:
			'Занятия проводят опытные специалисты, которые не только учат, но и вдохновляют детей на достижение высоких результатов.',
		image: '/img/advantages/strong-teachers.svg',
	},
	{
		id: 6,
		title: 'Сертификат об окончании курса',
		description:
			'После завершения обучения ребёнок получит сертификат, который подтвердит его знания и может стать первым шагом в профессии.',
		image: '/img/advantages/certificate.svg',
	},
]

export default function AdvantagesSection() {
	const advantagePairs = []
	for (let i = 0; i < advantages.length; i += 2) {
		advantagePairs.push(advantages.slice(i, i + 2))
	}

	return (
		<section id="about" className={styles.advantagesSection}>
			<SectionTitle>Наши преимущества</SectionTitle>
			<div className={styles.advantagesSection__wrapper}>
				{advantagePairs.map((pair, rowIndex) => (
					<div
						className={`${styles.advantageRow} ${
							rowIndex % 2 === 1 ? styles.reverse : ''
						}`}
						key={`row-${rowIndex}`}
					>
						{pair.map((advantage, index) => (
							<div
								className={`${styles.advantageCard} ${
									index === 0 ? styles.small : styles.large
								}`}
								key={advantage.id}
							>
								<div className={styles.advantageCard__text}>
									<h3 className={styles.advantageCard__title}>
										{advantage.title}
									</h3>
									<p className={styles.advantageCard__description}>
										{advantage.description}
									</p>
								</div>
								<div className={styles.advantageCard__image}>
									<img src={advantage.image} alt={advantage.title} />
								</div>
							</div>
						))}
					</div>
				))}
			</div>
		</section>
	)
}
